export enum CaseSubCriterias {
  CASE_NUMBER = "Case Number",
  DEBTOR_NUMBER = "Debtor Number",
  DEBTOR_NAME = "Debtor Name",
  KID = "KID",
  INVOICE_NUMBER = "Invoice Number",
  ADDITIONAL_REFERENCE_1 = "ADDITIONAL_REFERENCE_1",
  ADDITIONAL_REFERENCE_2 = "ADDITIONAL_REFERENCE_2",
}
